export default {"src":"/_next/static/media/0xa2107fa5b38d9bbd2c461d6edf11b11a50f6b974.2e1b6b93.svg","height":129,"width":129,"blurWidth":0,"blurHeight":0};